/* jshint node:true */
'use strict';

    // Date comparison taken from
    // http://stackoverflow.com/questions/492994/compare-two-dates-with-javascript

var dateTime                = require('../configs/config.datetime.js');
var moment                  = require('moment-timezone');

module.exports = {

    dateToKey: function(oDate){
        return this.dateFormat(oDate,'date12')
    },

    paramToDate: function(sParam){

        if(typeof sParam === 'undefined' || sParam === null || !sParam){
            return null;
        }
        var iYear = sParam.substr(0,4);
        var iMonth = sParam.substr(4,2);
        var iDay = sParam.substr(6,2);

        return this.dateToObject(iYear+'-'+iMonth+'-'+iDay);

    },

    dateDayNamesMedium: function(){
        return dateTime.dayNamesMedium;
    },

    dateFormat: function(ISODate,dateFormat,showTimezone){

        if (ISODate === undefined){
            return ISODate;
        }

        if(dateFormat === undefined){
            dateFormat = 'date6';
        }

        showTimezone = showTimezone || false;

        var formatsMap  = dateTime.dateFormats;
        var utcMoment   = moment(ISODate);//, moment.ISO_8601
        var localMoment = moment(utcMoment.utc().toDate());

        dateFormat = formatsMap[dateFormat];
        var dateString = localMoment.format(dateFormat);
        //console.log(localMoment.format('z'));
        //window.moment().tz(window.jstz.determine().name()).format("z");
        //if ($(element).hasClass("time") && showTimezone === "true") {
        //    var currentTimezone = espn_ui.Helpers.timezones.getCurrentTimezone();
        //    dateString += " " + espn_ui.Behaviors.date_timezone.replace(currentTimezone);
        //}

        return dateString;
    },

    /**
    * Converts the date in d to a date-object using moment
    **/
    dateToObject:function(d) {
        return moment(d).toDate();
    },

    /**
    * Compare two dates (could be of any type supported by the convert
    * function above) and returns:
    *  -1 : if a < b
    *   0 : if a = b
    *   1 : if a > b
    * NaN : if a or b is an illegal date
    * NOTE: The code inside isFinite does an assignment (=).
    **/
    dateCompare:function(a,b) {
        return (
            isFinite(a=this.dateToObject(a).valueOf()) &&
            isFinite(b=this.dateToObject(b).valueOf()) ?
            (a>b)-(a<b) :
            NaN
        );
    },

    /**
    * Checks if date in d is between dates in start and end.
    * Returns a boolean or NaN:
    *    true  : if d is between start and end (inclusive)
    *    false : if d is before start or after end
    *    NaN   : if one or more of the dates is illegal.
    * NOTE: The code inside isFinite does an assignment (=).
    **/
    dateInRange:function(d,start,end) {
       return (
            isFinite(d=this.dateToObject(d).valueOf()) &&
            isFinite(start=this.dateToObject(start).valueOf()) &&
            isFinite(end=this.dateToObject(end).valueOf()) ?
            start <= d && d <= end :
            NaN
        );
    }

};



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/mixins/DateFormatMixin.js
 **/